import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Card, CardBody, Spinner, Table } from 'reactstrap';
import { request } from '../api';
import Layout, { horizonLabel } from '../components/Layout';

export default function StrategyList() {
  const [data, setData] = useState(null), [options, setOptions] = useState(null), [error, setError] = useState('');
  useEffect(() => {
    document.title = 'My Strategies | ForecastNest';
    let live = true;
    Promise.all([request('/strategies'), request('/options')])
      .then(([d, o]) => { if (live) { setData(d); setOptions(o); } })
      .catch(e => live && setError(e.message));
    return () => { live = false; };
  }, []);
  const universe = id => options?.universes.find(u => u.id === id)?.title || id;
  const full = data && data.limit >= 0 && data.strategies.length >= data.limit;
  return <Layout title="My strategies" error={error}>
    <Card className="mb-3"><CardBody>
      <p className="mb-2">Write your own research strategy, run it through any AI you use, and see how its picks do against SPY. ForecastNest builds the prompt around your strategy and settles every run from market prices.</p>
      <p className="text-muted fs-13 mb-0"><i className="ri-lock-line me-1" />Your strategies, their prompts and their results are visible to you alone — no other member can read them, whatever their plan.</p>
    </CardBody></Card>
    {!data && !error && <div className="text-center py-5"><Spinner /> Loading…</div>}
    {data && <>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        {full
          ? <span className="text-muted fs-13">{data.limit === 1 ? 'Your plan keeps one strategy. Archive it to start another, or ' : `Your plan keeps up to ${data.limit} strategies. Archive one to start another, or `}<Link to="/pricing">see plans</Link>.</span>
          : <Link className="btn btn-primary" to="/strategies/new"><i className="ri-add-line align-bottom me-1" />New strategy</Link>}
        <span className="text-muted fs-12">{data.strategies.length}{data.limit >= 0 ? ` of ${data.limit}` : ''} strategies{options?.usage && !options.usage.unlimited ? ` · ${options.usage.remaining} of ${options.usage.limit} research runs left this month` : ''}</span>
      </div>
      {data.strategies.length
        ? <div className="table-responsive"><Table className="align-middle">
          <thead className="table-light"><tr><th>Strategy</th><th>Picks</th><th>Horizon</th><th>Universe</th><th>Version</th><th>Runs</th></tr></thead>
          <tbody>{data.strategies.map(s => <tr key={s.id}>
            <td><Link to={`/strategies/${s.id}`} className="fw-medium">{s.name}</Link></td>
            <td>{s.pick_count}</td><td>{horizonLabel(s.horizon)}</td><td>{universe(s.universe)}</td>
            <td><Badge color="light" className="text-body">v{s.current_version}</Badge></td>
            <td>{s.runs} <span className="text-muted fs-12">({s.settled_runs} settled)</span></td>
          </tr>)}</tbody>
        </Table></div>
        : <Card><CardBody className="text-center p-4 text-muted">No strategies yet. Start from a template or from scratch.</CardBody></Card>}
    </>}
  </Layout>;
}
